import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Dialog, DialogTitle, DialogContent, IconButton, MenuItem } from '@mui/material';
import { DataGridPro } from '@mui/x-data-grid-pro';
import Iconify from '../../../../reusable-components/iconify';
import { ScopeGuard } from '../../../../reusable-components/scopes';
import { getOrdersSent } from '../../../../api/orders';
import { VIEW_ORDER_HISTORY } from '../../../../reusable-components/datagrid/orderColumns';
import FileThumbnail from '../../../../reusable-components/file-thumbnail';
import { HOST_API_URL } from '../../../../config-global';
import DropdownAction from '../../../../reusable-components/dropdown-action/DropdownAction';
import CloseIconButton from '../../../../reusable-components/basic-buttons/CloseIconButton';

export default function OrdersSent() {
  const [open, setOpen] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const { id = '' } = useParams();
  const [data, setData] = useState([]);

  const getSent = async () => {
    const response = await getOrdersSent(id);
    if (response.status === 200) {
      setData(response.data);
    }
  };

  useEffect(() => {
    if (id && open) {
      getSent();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, open]);

  const handleClose = () => {
    setOpen(false);
  };

  const ActionButtons = (params) => {
    const { id } = params.row;
    return (
      <IconButton
        color="info"
        onClick={() => {
          window.open(`${HOST_API_URL}Api/DownloadOrderSent?id=${id}`, '_blank');
        }}
      >
        <Iconify icon="mdi:tray-arrow-down" />
      </IconButton>
    );
  };

  const actions = {
    field: 'actions',
    headerName: 'Actions',
    disableReorder: true,
    width: 100,
    renderCell: (params) => ActionButtons(params),
    id: 'actions',
    className: 'actions',
  };
  const fileExtension = {
    field: 'File Type',
    headerName: 'File Type',
    width: 100,
    renderCell: (params) =>
      params.row.fileName ? (
        <FileThumbnail key={params.row.fileName} file={params.row.fileName} tooltip sx={{ width: 32, height: 32 }} />
      ) : (
        ''
      ),
    id: 'fileExtension',
    className: 'fileExtension',
  };
  const sent = {
    field: 'sent',
    headerName: 'Sent',
    width: 90,
    id: 'main',
    className: 'main',
    renderCell: (params) => {
      const { sent } = params.row;
      return sent ? <Iconify icon="material-symbols:check-circle-outline" color="primary" /> : <></>;
    },
  };

  return (
    <>
      <ScopeGuard scopes={['Edit-Order']} allowAdmin>
        <MenuItem
          disableRipple
          disableGutters
          sx={{ p: 0, minHeight: 'unset', '&:hover': { bgcolor: 'transparent' } }}
          onClick={handleClickOpen}
        >
          <DropdownAction badgeIcon="mdi:eye-outline">View Order History</DropdownAction>
        </MenuItem>
      </ScopeGuard>

      <Dialog
        open={open}
        onClose={(event, reason) => {
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
          handleClose();
        }}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle sx={{ textAlign: 'center' }}>
          View History
          <CloseIconButton onClick={handleClose}/>
        </DialogTitle>
        <DialogContent>
          <div style={{ height: 'calc(100vh - 200px)', width: '100%' }}>
            <DataGridPro
              getRowHeight={() => 'auto'}
              rows={data}
              columns={[...VIEW_ORDER_HISTORY, fileExtension, sent, actions]}
              disableSelectionOnClick
            />
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}